import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import React from "react"

import FileChip from "@/components/upload/components/display/FileChip"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { ProductFileRowActions } from "@/screens/Products/components/Product/Information/ProductFiles/ProductFileTable/ProductFileRowActions"
import {
  FileTypeToChipColorMap,
  type ProductFileType,
} from "@/screens/Products/components/Product/Information/types/productFile"

export const useProductFilesColumns = (onRemove: (fileId: string) => Promise<boolean>): ColumnDef<SignedUrl>[] => {
  return [
    {
      accessorKey: "fileType",
      header: "Type",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 100,
      cell: ({ row }) => {
        const chipInfo = FileTypeToChipColorMap[row.original.file?.fieldGroup as unknown as ProductFileType]
        return (
          <Chip
            className='mr-2 rounded-full'
            label={chipInfo.label}
            sx={{
              backgroundColor: chipInfo.color,
            }}
          />
        )
      },
    },
    {
      accessorKey: "file",
      header: "File",
      enableSorting: false,
      sortingFn: "alphanumeric",
      size: 150,
      cell: ({ row }) => <FileChip file={row.original} showExtension={true} />,
    },
    {
      accessorKey: "description",
      header: "Description",
      enableSorting: false,
      sortingFn: "alphanumeric",
      size: 300,
      cell: ({ row }) => row.original.file?.label || "",
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 72,
      cell: ({ row }) => <ProductFileRowActions row={row} onRemove={onRemove} />,
    },
  ]
}
